import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";

import type { FCWithChildren } from "koljobs-types";

export const QuickViewPhoto: FCWithChildren = ({ children }) => {
  return (
    <Zoom zoomMargin={16} wrapStyle={{ minWidth: "100%" }}>
      <div className="relative min-w-full">{children}</div>
    </Zoom>
  );
};
